export default function AJAX_Examples() {
  return (
    <div>
      <h1>AJAX_Examples</h1>
      <p>This is the AJAX_Examples component.</p>
    </div>
  );
}